/**
 * Shared alias + landing-path validation for the redirect tools.
 * (AliasManageModal keeps its own inline copy for now; new code should use this.)
 */

// URLs/words that can't be used as an alias (they'd shadow real routes).
export const RESERVED_URLS = [
  "stats", "api", "hs", "index", "admin", "dashboard", "app", "www",
  "mail", "email", "ftp", "blog", "dev", "test", "staging", "prod",
  "production", "cdn", "assets", "static", "public", "private", "secure",
  "login", "logout", "auth", "oauth", "register", "signup", "signin",
  "account", "profile", "settings", "config", "help", "support", "contact",
  "about", "terms", "privacy", "legal", "robots", "sitemap", "favicon",
  "apple-touch-icon", "ba",
];

/** Validate an alias name (the short go.clozesure.com/<name> path). */
export function validateAliasName(value) {
  const v = (value || "").toLowerCase().trim();
  if (!v) return { valid: false, message: "" };
  if (v.length < 3 || v.length > 50)
    return { valid: false, message: "Must be 3–50 characters" };
  if (!/^[a-z0-9-]+$/.test(v))
    return { valid: false, message: "Lowercase letters, numbers and hyphens only" };
  if (v.startsWith("-") || v.endsWith("-") || v.includes("--"))
    return { valid: false, message: "No leading/trailing or double hyphens" };
  if (RESERVED_URLS.includes(v))
    return { valid: false, message: "That name is reserved" };
  return { valid: true, message: "" };
}

/**
 * Validate a landing path. Blank = homepage. Otherwise lowercase
 * alnum/hyphen segments joined by single slashes, optionally led by an
 * @subdomain segment (e.g. "@assets/brochure" → assets.clozesure.com/brochure).
 */
export function validateLandingPath(raw) {
  const clean = (raw || "").trim().replace(/^\/+|\/+$/g, "");
  if (!clean) return { valid: true, message: "" };
  if (/^@[a-z0-9]+(\/[a-z0-9-]+)*$/.test(clean)) return { valid: true, message: "" };
  if (/^[a-z0-9-]+(\/[a-z0-9-]+)*$/.test(clean)) return { valid: true, message: "" };
  return {
    valid: false,
    message:
      "Path: lowercase letters, numbers, hyphens, “/” and an optional @subdomain",
  };
}
